// src/stores/auth-store.js — Reactive auth/session state store
export const AuthStore = (function() {
    const _state = {
        currentUser: null,      // {email, name, picture, status, isAdmin}
        isAdmin: false,
        idToken: null,          // in-memory session token
        sessionStatus: null,    // 'authenticated', 'pending', 'expired', null
    };
    const _subscribers = {};

    function _notify(key) {
        (_subscribers[key] || []).forEach(function(fn) { try { fn(_state[key]); } catch(e) {} });
        (_subscribers['*'] || []).forEach(function(fn) { try { fn(key, _state[key]); } catch(e) {} });
    }

    return {
        get: function(key) { return _state[key] !== undefined ? _state[key] : null; },
        set: function(key, value) { _state[key] = value; _notify(key); },
        setAll: function(obj) { Object.keys(obj).forEach(function(k) { _state[k] = obj[k]; _notify(k); }); },
        on: function(key, fn) {
            if (!_subscribers[key]) _subscribers[key] = [];
            _subscribers[key].push(fn);
            return function() { _subscribers[key] = _subscribers[key].filter(function(f) { return f !== fn; }); };
        },
        clear: function() {
            _state.currentUser = null;
            _state.isAdmin = false;
            _state.idToken = null;
            _state.sessionStatus = null;
            _notify('currentUser'); _notify('isAdmin'); _notify('idToken'); _notify('sessionStatus');
        },
        isAuthenticated: function() { return _state.sessionStatus === 'authenticated' && _state.currentUser !== null; },
    };
})();
